import { render, staticRenderFns } from "./FornecedorUsuarioForm.vue?vue&type=template&id=5148e21a"
import script from "./FornecedorUsuarioForm.vue?vue&type=script&lang=js"
export * from "./FornecedorUsuarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports